import AnimateOnEnter from "@/ui/animations/AnimateOnEnter"
import Typography from "@/ui/atoms/Typography"
import Box from "@/ui/layout/Box"
import { classNames, ResponsiveStringValue } from "@punks/ui-core"
import { ReactNode } from "react"

export type ListItemClasses = {
  root?: string
  title?: string
  subtitle?: string
  caption?: string
  image?: string
}

export interface ListItemBlockProps {
  title?: ReactNode
  subtitle?: ReactNode
  caption?: ReactNode
  image?: ReactNode
  decoration?: ReactNode
  imageMartingTop?: ResponsiveStringValue
  textPadding?: ResponsiveStringValue
  classes?: ListItemClasses
  className?: string
  centerXs?: boolean
}

const ListItemBlock = ({
  title,
  caption,
  subtitle,
  image,
  decoration,
  imageMartingTop,
  textPadding,
  classes,
  className,
  centerXs,
}: ListItemBlockProps) => {
  return (
    <div className={classNames("relative", classes?.root, className)}>
      {image && (
        <Box mt={imageMartingTop} className="mb-6 relative">
          {decoration && (
            <AnimateOnEnter delay={250} animationType="fadeIn">
              <div className="absolute inset-0 z-[-1]">{decoration}</div>
            </AnimateOnEnter>
          )}
          <div className={classes?.image}>{image}</div>
        </Box>
      )}

      <Box
        px={textPadding}
        className={centerXs ? "text-center xl:text-left" : ""}
      >
        {caption && (
          <Typography
            className={classes?.caption}
            variant={"body4"}
            color={"primary"}
            weight={"bold"}
          >
            {caption}
          </Typography>
        )}
        {title && (
          <Typography
            className={classNames("my-3", classes?.title)}
            variant={["body2", "subtitle1"]}
            weight={"bold"}
          >
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography
            className={classNames("mt-6", classes?.caption)}
            variant={["body3", "body2"]}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </div>
  )
}

export default ListItemBlock
